import { render, staticRenderFns } from "./Tidspunkt.vue?vue&type=template&id=5872abb4&scoped=true"
import script from "./Tidspunkt.vue?vue&type=script&lang=js"
export * from "./Tidspunkt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5872abb4",
  null
  
)

export default component.exports